/**
 * Facts shown in the project settings "关于与版本" area.
 *
 * 版本、参考图和交互条目来自当前交付契约；正式开发状态是明确的否定事实。
 * 这里不包含 API、数据库、Redis 或部署状态，因为这些能力在本阶段尚未创建。
 */
export const PROTOTYPE_METADATA = {
  version: '1.0.0',
  references: [
    'reference-1.png',
    'reference-2.png',
    'reference-3.png',
    'reference-4.png',
    'reference-5.png',
  ],
  interactionCount: 204,
  pageCount: 38,
  formalDevelopmentStarted: false,
} as const
